// Code review - Completed
// Documentation - Completed
import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import {
  itemsHeader,
} from "../components/HeaderAttribute";
import AddScreenTitle from "../components/AddScreenTitle";
import { mainTable } from "../css/Common";
import Buttons from "../components/Buttons";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import { useLocation } from "react-router-dom";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
} from "../services/APIConnection";
import toast from "react-hot-toast";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Commoditiespopup from "../popup-containers/ItemsPopup";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import DropDown from "../ReusableComponents/DropDown";
import Itemspopup from "../popup-containers/ItemsPopup";
import Loader from "../ReusableComponents/Loader";

const Items = () => {
  //visiable state handle
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  //location path handle states
  const location = useLocation();

  //commodities dropdown state handle
  const [commoditiesCategories, setCommoditiesCategories] = useState([]);
  const [commoditiesCategories1, setCommoditiesCategories1] = useState([]);
  const [bindCategories, setBindCategories] = useState([]);
  const [bindUnitOfMeasure, setBindUnitOfMeasure] = useState([]);
  const [bindItemType, setBindItemType] = useState([]);



  //handle payload state
  const [mstItemId, setMstItemsId] = useState("");
  const [itemsFileds, setItemsFileds] = useState({
    categories: "",
    name: "",
    description: "",
    itemUOM: "",
    reOrderLevel: "",
    itemType: ""
  });

  const [itemsFieldsError, setItemsFieldsError] = useState({
    categoriesError: "",
    nameError: "",
    descriptionError: "",
    unitOfMeasureError: "",
    reOrderLevelError: "",
    itemTypeError: ""
  });
  const mstClientId = sessionStorage.getItem("MstClientId");

  //popup state handle
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [textFiledsPopupData, setTextFiledsPopupData] = useState([]);
  const [autoCompleteDropDownPopupData, setAutoCompleteDropDownPopupData] =
    useState({});

  const [isOpen, setIsOpen] = useState(false);

  const showAdd = () => {
    setVisibleTable(false);
    setVisibleAdd(true);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];

    setItemsFileds((prevFields) => ({
      ...prevFields,
      openingDate: formattedDate,
    }));
  };

  const bindGridData = async (fetchData) => {
    console.log("fetchData", fetchData);
    try {

      const data = {
        mstClientId: mstClientId,
      };
      setIsLoading(true)
      let response = await BindPostAPI(data, "ItemsAPI/BindItems");

      setTableData(response.data.Table);
      setIsLoading(false)
    } catch (error) {
      console.log(`Data fetching error: ${error}`);
    }
  };



  const cancel = async () => {
    setIsLoading(false)
    setVisibleAdd(false);
    setVisibleTable(true);
    clear();
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    bindGridData();
  };

  const clear = () => {
    setBindCategories([])
    setItemsFileds({
      categories: "",
      name: "",
      description: "",
      itemUOM: "",
      reOrderLevel: "",
      itemType: ""
    });
    setMstItemsId("");
    setItemsFieldsError({
      categoriesError: "",
      nameError: "",
      descriptionError: "",
      unitOfMeasureError: "",
      reOrderLevelError: "",
      itemTypeError: ""
    });
  };

  const getCommodityUOMDDValues = async () => {

    // Unit of Measure Dropdown binding
    const response = await BindAPI("ItemsAPI/BindUOM");
    const getitemUOM =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstUOMId,
          label: item.UOM,
        }))
        : [];
    setBindUnitOfMeasure(getitemUOM);
  };

  const getItemTypeDDValues = async () => {

    const response = await BindAPI("ItemsAPI/BindItemType");
    const getItemTypeId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }))
        : [];
    setBindItemType(getItemTypeId);
  };


  const categoriesDropDown = async () => {

    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "ItemscategoryAPI/Binditemscategory");

  // Filter only rows where Inactive field is null
  const filtered = response.data.Table?.filter(
    (item) => item.InActivatedBy === null
  );

  setCommoditiesCategories(filtered);
};


  useEffect(() => {


    getCommodityUOMDDValues();
    getItemTypeDDValues();
    categoriesDropDown();
    categoriesDropDown1();
  }, [location.pathname ? location.pathname : null]);

  const categoriesDropDown1 = async () => {

    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "ItemscategoryAPI/Binditemscategory");
    const getCategory =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstItemCategoryId,
          label: item.ItemCategory,
        }))

        : [];
    setCommoditiesCategories1(getCategory);
  };
  useEffect(() => {
    if (

      location.pathname == "/items"
    ) {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);

      bindGridData();
    }
  }, [location]);

  const handleitemsFileds = (value, name) => {
    setItemsFileds({
      ...itemsFileds,
      [name]: value,
    });
  };
  const handleDropdownChange = (name, value) => {
    setItemsFileds((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validate = (flag) => {
    const errors = {};

    if (flag == 1 || flag == 2) {
      if (itemsFileds.categories == "") {
        errors.categories = `Select Item Category`;
      }

      // Validation logic for the contraceptiveFields.contraceptiveName input
      if (!itemsFileds.name.trim()) {
        errors.name = `Enter Item Name`;
      }

      if (itemsFileds.itemType == "") {
        errors.itemType = "Select Item Type";
      }


      // Validation logic for the Unit Of Measure input
      if (itemsFileds.itemUOM == "") {
        errors.unitOfMeasure = "Select Unit Of Measure";
      }


      // Validation logic for the SDP Level input
      if (!itemsFileds.reOrderLevel) {
        errors.reOrderLevel = "Enter Re-Order Level";
      } else if (!/^\d+$/.test(itemsFileds.reOrderLevel)) {
        errors.reOrderLevel = "Only numbers allowed";
      }



    }

    setItemsFieldsError({
      ...itemsFieldsError,
      categoriesError: errors.categories || "",
      nameError: errors.name || "",
      unitOfMeasureError: errors.unitOfMeasure || "",
      reOrderLevelError: errors.reOrderLevel || "",
      itemTypeError: errors.itemType || ""
    });

    return errors;
  };

  const handleSubmit = async (items, flag) => {

    setSubmitBtnDisabled(true);
    setIsLoading(true)
    const commoditiesValidation = validate(flag);

    if (Object.keys(commoditiesValidation).length !== 0) {
      setIsOpen(true);
      setIsLoading(false)
    }
    if (Object.keys(commoditiesValidation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1 || flag == 2) {

        const commoditiesData = {
          mstItemId: mstItemId ? mstItemId : 0,
          mstClientId: mstClientId,
          mstItemTypeId: itemsFileds.itemType,
          mstItemCategoryId: itemsFileds.categories,
          itemName: itemsFileds.name,
          description: itemsFileds.description,
          mstUOMId: itemsFileds.itemUOM,
          itemReOrderLevel: itemsFileds.reOrderLevel,
          createdBy: createdBy,
          flag: flag,

        };

        console.log("commoditiesData", commoditiesData);

        const response = await IUDAPI(
          commoditiesData,
          "ItemsAPI/IUDItems"
        );
        if (flag == 1) {
          if (response.data.Table[0].result === "S") {
            toast.success(`Items data added successfully 👍`, {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error(`Failed to add Items data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].result === "M") {
            toast.success(`Items data updated successfully 👍`, {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error(`Failed to update  Items data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        const commoditiesData = {
          mstItemId: mstItemId,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          commoditiesData,
          "ItemsAPI/IUDItems"
        );
        if (flag == 3) {
          // Delete
          if (response.data.Table[0].result === "D") {
            toast.success(`Items data deleted successfully 🗑️`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error(`Failed to delete Items data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 4) {
          // Block
          if (response.data.Table[0].result === "B") {
            toast.success(` Items data inactivated successfully 🚫`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error(`failed to inactivated  Items data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 5) {
          // Unblock
          if (response.data.Table[0].result === "UB") {
            toast.success(` Items data activated successfully ✅`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error(`failed to activated Items data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false)
    }
  };

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);


    setItemsFileds({
      ...itemsFileds,
      categories: tableData[rowIndex].MstItemCategoryId,
      name: tableData[rowIndex].ItemName,
      description: tableData[rowIndex].Description,
      itemUOM: tableData[rowIndex].MstUOMId,
      reOrderLevel: tableData[rowIndex].ItemReOrderLevel,
      itemType: tableData[rowIndex].MstItemTypeId,
    });
    setMstItemsId(tableData[rowIndex].MstItemId);
  };
  const handleOpen = (isOpen) => {
    // Popup open
    setpopUpOpen(isOpen);
  };
  const handleClose = () => {
    setpopUpOpen(false); // Popup close
  };

  const handleItemDetails = (rowIndex, flag) => {

    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setMstItemsId(tableData[rowIndex].MstItemId);

    setItemsFileds({
      ...itemsFileds,
      categories: tableData[rowIndex].MstItemCategoryId,

    });

    const CategoriesrowData = tableData[rowIndex];
    const CategoriesInfo = commoditiesCategories1.find(
      (CT) => CT.value == CategoriesrowData.MstItemCategoryId
    );
    const ResultCategories = [
      {
        value: CategoriesrowData.MstItemCategoryId,
        label: CategoriesInfo ? CategoriesInfo.label : "Unknown",
      },
    ];

    const UOMrowData = tableData[rowIndex];
    const UOMInfo = bindUnitOfMeasure.find((UM) => UM.value == UOMrowData.UOM);


    const filterUOM = bindUnitOfMeasure.filter(
      (x) => x.value == tableData[rowIndex].MstUOMId
    );

    const filterItemType = bindItemType.filter(
      (x) => x.value == tableData[rowIndex].MstItemTypeId
    );


    const dropdownDatas = [ResultCategories, filterUOM, filterItemType];
    setAutoCompleteDropDownPopupData(dropdownDatas);
    setTextFiledsPopupData(tableData[rowIndex]);

  };


  useEffect(() => {
    // Find the selected state in getCityDatas
    const SelectedValue = commoditiesCategories.find(
      (item) => item.MstItemTypeId == itemsFileds.itemType // Replace with the desired MstStateId
    );



    if (SelectedValue) {
      const cityLabels = commoditiesCategories
        .filter((item) => item.MstItemTypeId === SelectedValue.MstItemTypeId)
        .map((item) => ({
          MstItemCategoryId: item.MstItemCategoryId,
          ItemCategory: item.ItemCategory,
        }));

      const citySelected = cityLabels.map((LC) => ({
        value: LC.MstItemCategoryId, // Replace with the appropriate value
        label: LC.ItemCategory,
      }));
      setBindCategories(citySelected);
    } else {
    }
  }, [itemsFileds.itemType ? itemsFileds.itemType : null]);


  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Item"
          header={itemsHeader}
          records={tableData ? tableData : []}
          handleEdit={handleEdit}
          handleAction={handleItemDetails}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Items"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className={mainTable.grid3}>
                    <AutoDropDown
                      classStar="text-red-500"
                      title="Item Type"
                      options={bindItemType}
                      placeholder="Select"
                      Class="p-0"
                      name="itemType"
                      selectedOption={bindItemType.find(
                        (x) => x.value == itemsFileds.itemType
                      )}
                      controlFunc={(value, e) => {
                        handleitemsFileds(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setItemsFieldsError({
                          ...itemsFieldsError,
                          itemTypeError: itemsFileds.itemType
                            ? ""
                            : `Select Item Type`,
                        });
                      }}
                      errorMessage={itemsFieldsError.itemTypeError}
                    />

                    <AutoDropDown
                      classStar="text-red-500"
                      title="Item Category"
                      options={bindCategories}
                      placeholder="Select"
                      Class="p-0"
                      name="categories"
                      selectedOption={bindCategories.find(
                        (x) => x.value == itemsFileds.categories
                      )}
                      controlFunc={(value, e) => {
                        handleitemsFileds(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setItemsFieldsError({
                          ...itemsFieldsError,
                          categoriesError: itemsFileds.categories
                            ? ""
                            : `Select Item Category`,
                        });
                      }}
                      errorMessage={itemsFieldsError.categoriesError}
                    />

                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title="Item Name"

                        name="name"
                        maxLength={200}
                        content={itemsFileds.name}
                        controlFunc={(e) => {
                          setItemsFileds({
                            ...itemsFileds,
                            name: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setItemsFieldsError(
                            (itemsFieldsError) => ({
                              ...itemsFieldsError,
                              nameError:
                                itemsFileds.name.length > 0
                                  ? ""

                                  : `Enter Item Name`,
                            })
                          );
                        }}
                        errorMessage={itemsFieldsError.nameError}
                      />
                    </div>



                    <AutoDropDown
                      classStar="text-red-500"
                      title="Unit Of Measure"
                      options={bindUnitOfMeasure}
                      placeholder="Select"
                      Class="p-0"
                      name="itemUOM"
                      selectedOption={bindUnitOfMeasure.find(
                        (x) => x.value == itemsFileds.itemUOM
                      )}
                      controlFunc={(value, e) => {
                        handleitemsFileds(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setItemsFieldsError((itemsFieldsError) => ({
                          ...itemsFieldsError,
                          unitOfMeasureError:
                            itemsFileds.itemUOM
                              ? ""
                              : `Select Unit Of Measure`,
                        }));
                      }}
                      errorMessage={itemsFieldsError.unitOfMeasureError}
                    />


                    <InputText
                      classStar="text-red-500"
                      inputType="text"
                      title="Re-Order Level"
                      placeholder="100"
                      name="reOrderLevel"
                      maxLength={6}
                      content={itemsFileds.reOrderLevel}
                      controlFunc={(e) => {
                        setItemsFileds({
                          ...itemsFileds,
                          reOrderLevel: e.target.value,
                        });
                      }}
                      controlFuncBlur={() => {
                        setItemsFieldsError(() => ({
                          ...itemsFieldsError,
                          reOrderLevelError: itemsFileds.reOrderLevel
                            ? /^\d+$/.test(itemsFileds.reOrderLevel)
                              ? ""
                              : "Only numbers allowed"
                            : "Enter Re-Order Level",
                        }));
                      }}
                      errorMessage={itemsFieldsError.reOrderLevelError}
                    />

                    <InputText
                      inputType="text"
                      title="Description"
                      placeholder="Description"
                      name="description"
                      maxLength={500}
                      content={itemsFileds.description}
                      controlFunc={(e) => {
                        setItemsFileds({
                          ...itemsFileds,
                          description: e.target.value,
                        });
                      }}
                    />

                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleItemDetails}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title="Item"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Itemspopup
            data={textFiledsPopupData}
            data2={autoCompleteDropDownPopupData}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Items;
